import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApiError, AuthService, BaseVisualizacao, BaseVisualizacaoService, ConfigService, DataTablesService, MessageService, Task, TaskService } from '../../core';
import { ConfigEmpresa, isConfigEmpresaVersaoIntegracaoErp1 } from '../configuracoes/app/empresa';
import { IntegrationMercado, IntegrationMercadoHttpService } from '../configuracoes/integration/mercado';
import { MercadoCrudHttpService } from './services';

import { Mercado } from './mercado';
import { MercadoOptions } from './mercado-options';

@Component({
    selector: 'sgt-mercado',
    templateUrl: './mercado.component.html',
    styleUrls: ['./mercado.component.less']
})
export class MercadoComponent implements BaseVisualizacao<Mercado>, OnInit {
    configEmpresa: ConfigEmpresa;
    isIntegracaoErpV1: boolean;
    entities: Mercado[];
    idDataTable = 'tableMercados';
    dataTable: any;

    // Options
    options: MercadoOptions;

    constructor(private activatedRoute: ActivatedRoute,
                private authService: AuthService,
                private baseVisualizacaoService: BaseVisualizacaoService,
                private configService: ConfigService,
                private messageService: MessageService,
                private dataTablesService: DataTablesService,
                private taskService: TaskService,
                private mercadoCrudHttpService: MercadoCrudHttpService,
                private integrationMercadoHttpService: IntegrationMercadoHttpService) { }


    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isIntegracaoErpV1 = isConfigEmpresaVersaoIntegracaoErp1(this.configEmpresa);

        this.createOptions();
        this.search();
    }

    /** Cria as opções disponíveis para serem executadas pelos usuários */
    private createOptions() {
        this.options = new MercadoOptions();
        // Import ERP v1
        this.options.canImportErp_v1 = this.canImportErp_v1();
    }

    search() {
        this.mercadoCrudHttpService.search()
            .subscribe(
                entities => {
                    this.entities = entities;
                    this.showTable();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os mercados', error)
            );
    }

    showTable() {
        this.dataTablesService.showTable(`#${this.idDataTable}`, this.dataTable)
            .then(dataTable => {
                this.dataTable = dataTable;
                this.baseVisualizacaoService.ativarArmazenamento(this.dataTable, null);
            });
    }

    insert() {
        this.baseVisualizacaoService.insert(this.activatedRoute);
    }

    edit(entity: Mercado) {
        this.baseVisualizacaoService.edit(entity.id, this.activatedRoute);
    }

    delete(entity: Mercado) {
        this.messageService.confirm(`Deseja realmente excluir o mercado ${entity?.nome ?? ''}?`).then(result => {
            if (result) {
                this.mercadoCrudHttpService.delete(entity.id)
                    .subscribe(
                        response => {
                            this.messageService.success('', response);
                            this.search();
                        },
                        (error: ApiError) => this.messageService.error(error.message, `Erro ao excluir o mercado ${entity?.nome ?? ''}`, error)
                    );
            }
        });
    }

    /** Verifica se pode importar os mercados do ERP V1 */
    private canImportErp_v1(): boolean {
        // Somente se for a versão 1
        if (!this.isIntegracaoErpV1) {
            return false;
        }

        return this.authService.podeImportarErp();
    }

     /** Executa a integração de leitura dos mercados com os sistemas ERP's */
    importErp_v1() {
        const task = new Task('Importando os mercados do sistema ERP', 'Executando importação dos mercados do sistema ERP');
        this.taskService.add(task, task.description);

        const entityIntegration = new IntegrationMercado();
        this.integrationMercadoHttpService.execReadIntegration(entityIntegration)
            .subscribe(
                () => {
                    this.taskService.success(task, 'Importação dos mercados do sistema ERP realizada com sucesso');
                    this.search();
                },
                (error: ApiError) => this.taskService.error(task, 'Erro ao realizar a importação dos mercados do sistema ERP', error.message, error)
            );
    }
}
